<template>
  <div v-loading="loading">
    <div class="title">我的批改（挑战）</div>
    <el-alert
      v-if="wait_evaluate_count"
      style="margin-bottom: 4px"
      :title="'您还有' + wait_evaluate_count + '份作品未完成批改，请尽快完成～'"
      type="warning"
      :closable="false"
      show-icon
    >
    </el-alert>
    <div class="search-box">
      <el-input
        clearable
        size="mini"
        @keyup.enter.native="handleSearch"
        placeholder="请输入挑战名称"
        class="w-180 mr-12"
        v-model="search.challenge_name"
      ></el-input>
      <el-input
        clearable
        size="mini"
        placeholder="请输入学员名称"
        @keyup.enter.native="handleSearch"
        class="w-160 mr-12"
        v-model="search.student_search"
      ></el-input>
      <el-select
        clearable
        placeholder="请选择挑战作品状态"
        size="mini"
        v-model="search.status"
        class="mr-12 w-160"
        ><el-option
          v-for="(item, key) in statusOption"
          :key="key"
          :label="item"
          :value="key"
        ></el-option
      ></el-select>
      <el-input
        clearable
        size="mini"
        @keyup.enter.native="handleSearch"
        placeholder="请输入来源"
        class="w-160 mr-12"
        v-model="search.company_name"
      ></el-input>
      <el-button type="primary" size="mini" @click="handleSearch"
        >搜索</el-button
      >
      <el-button type="default" size="mini" @click="handleReset"
        >重置</el-button
      >
    </div>
    <el-table :data="recordList" :stripe="true">
      <el-table-column width="80" label="作品编号" prop="id"></el-table-column>
      <el-table-column width="100" label="学员">
        <template slot-scope="scope">
          <span v-if="scope.row.student">{{ scope.row.student.name }}</span>
          <span v-else-if="scope.row.source">{{
            scope.row.source.platform_student_name
          }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="挑战名称" prop="challenge.name"></el-table-column>
      <el-table-column width="100" label="提交次数">
        <template slot-scope="scope">第 {{ scope.row.times }} 次提交</template>
      </el-table-column>
      <el-table-column width="140" label="来源" prop="company_name">
        <template slot-scope="scope">{{
          scope.row.challenge_work_source.name
        }}</template>
      </el-table-column>
      <el-table-column width="200" label="批改时间">
        <template slot-scope="scope">
          <span v-if="scope.row.teacher_evaluate_at">{{
            scope.row.teacher_evaluate_at
          }}</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column
        width="75"
        label="状态"
        prop="status_label"
      ></el-table-column>
      <el-table-column
        width="100"
        label="学员反馈"
        prop="student_comment"
      ></el-table-column>
      <el-table-column width="100">
        <template slot="header">
          <div @click="toggleShowContent" class="toggle-show">
            <span>批改价格</span>
            <i class="el-icon-view toggle-show-icon"></i>
          </div>
        </template>
        <template slot-scope="scope">
          <show-hide-content
            :value="scope.row.teacher_evaluate_price"
            :show.sync="isShow"
          ></show-hide-content>
        </template>
      </el-table-column>
      <el-table-column width="110" label="操作" fixed="right">
        <template slot-scope="scope">
          <el-link
            type="danger"
            class="mr-12"
            :underline="false"
            v-if="
              authPermissions.includes(
                'expert_service.api.fuwu_admin.v2.expert.challenges.works.release'
              ) && scope.row.status === 2
            "
            @click="releaseTask(scope.row.id, scope.$index)"
          >
            释放
          </el-link>
          <el-link
            type="primary"
            :underline="false"
            @click="showOrder(scope.row.id)"
          >
            {{ scope.row.status === 2 ? "去批改" : "详情" }}
          </el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="total, prev, pager, next, jumper"
      @current-change="handleChangePage"
      :current-page.sync="pagination.currentPage"
      :page-size="pagination.pageSize"
      :total="pagination.total"
      :hide-on-single-page="true"
    >
    </el-pagination>
  </div>
</template>

<script>
import { mapState } from "vuex";
import challengeService from "@/global/service/challenge";
import ShowHideContent from "@/components/ShowHideContent";

export default {
  components: {
    ShowHideContent
  },
  data() {
    return {
      loading: true,
      isShow: false,
      recordList: [],
      homeworkId: null,
      wait_evaluate_count: null,
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      search: {
        challenge_name: null,
        student_search: null,
        status: null,
        company_name: null
      },
      statusOption: {
        1: "已创建",
        2: "已抢占",
        3: "已驳回",
        4: "已批改",
        5: "已评论"
      }
    };
  },
  computed: {
    ...mapState(["authPermissions"])
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      const params = {
        page: this.pagination.currentPage,
        page_size: this.pagination.pageSize,
        ...this.search
      };
      this.loading = true;
      challengeService
        .myChallengesWork(params)
        .then(res => {
          this.recordList = res.list;
          this.pagination.total = res.pagination.total;
          this.pagination.currentPage = res.pagination.current_page;
          this.wait_evaluate_count = res.base_info.wait_evaluate_count;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleSearch() {
      this.pagination.currentPage = 1;
      this.getData();
    },
    handleChangePage(e) {
      this.pagination.currentPage = e;
      this.getData();
    },
    handleReset() {
      this.search = {
        project_name: null,
        student_name: null,
        status: null
      };
      this.pagination.currentPage = 1;
      this.getData();
    },
    showOrder(id) {
      this.$router.push({
        name: "ChallengeWorkDetail",
        params: { id }
      });
    },
    releaseTask(id, index) {
      this.$confirm(
        "作品释放后其他人可以再次抢单，确定释放这份作品？",
        "提示",
        {
          //  confirmButtonText: '确定',
          //   cancelButtonText: '取消',
          type: "warning"
        }
      ).then(() => {
        challengeService
          .challengeWorkRelease({ challenge_work_id: id })
          .then(() => {
            this.$message({
              type: "success",
              message: "任务释放成功!"
            });
            this.recordList.splice(index, 1);
          });
      });
    },
    toggleShowContent() {
      this.isShow = !this.isShow;
    }
  }
};
</script>
<style lang="less" scoped>
.search-box {
  margin: 20px 0 10px;
}
</style>
